import { Config } from './configType';

export const config: Config = {
  production: false,
  keyCloak: {
    url: 'https://senhub-dev-auth.senforce.ai',
    realm: 'senhub',
    clientId: 'senhub',
    serverLoginFlow: 'jwt',
  },
  graphql: {
    url: 'https://senhub-dev-admin.senforce.ai/v1/graphql',
  },
  rest: {
    url: 'https://senhub-dev.senforce.ai/api',
  },
  googleMap: {
    key: 'AIzaSyAE_erelWAYqPGjNuQaivhWPN2AnNx4u8M',
    mapId: '3cd26b2cdfb36b22',
  },
  apiKey: {
    hasDescription: true,
  },
  customer: {
    createS3BucketEnabled: true,
  },
};

export default config;
